import { render } from "./PaymentChooseCard.vue?vue&type=template&id=a4e98930&scoped=true&lang=pug"
import script from "./PaymentChooseCard.vue?vue&type=script&lang=js"
export * from "./PaymentChooseCard.vue?vue&type=script&lang=js"

import "./PaymentChooseCard.vue?vue&type=style&index=0&id=a4e98930&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4e98930"]])

export default __exports__